<span class="loader" [hidden]="loaded"></span>
<div class="{{showBrandValue}}">
<crs-core [class.ui-body-disabled]="!loaded"></crs-core></div>
<div class="pageLoader" #overlay>
    <div class="blackout">
        <span class="loader"></span>
    </div>
</div>